import { $amplitudeExperimentsAtom } from '@client/core/atoms/amplitude.js';
import { $config } from '@client/core/atoms/config.js';
import { ExperimentVariants } from '@schibsted-nmp/advertising-shared';

const experimentVerticals = ['car', 'boat'];

const getExperimentBoatsQuery = (
  query: string,
  experimentVariant: ExperimentVariants
) => {
  const experimentQuery =
    experimentVariant === ExperimentVariants.Treatment_1
      ? 'Både'
      : 'Kategori Både';

  if (query === 'boats') return 'Både';

  return `${query} ${experimentQuery}`;
};

const getExperimentCarsQuery = (
  query: string,
  experimentVariant: ExperimentVariants
) => {
  const experimentQuery =
    experimentVariant === ExperimentVariants.Treatment_1
      ? 'Biler'
      : 'Kategori Biler';

  if (query === 'cars') return 'Biler';

  return `${query} ${experimentQuery}`;
};

export const getExperimentQuery = (query: string) => {
  const { vertical } = $config.get() ?? {};

  const { experiments } = $amplitudeExperimentsAtom.get();
  const experimentVariant = experiments['advt-adsense-context-dba'];

  if (
    !experimentVariant ||
    experimentVariant === ExperimentVariants.Control ||
    !experimentVerticals.includes(vertical as string)
  ) {
    return query;
  }

  if (['boat'].includes(vertical as string)) {
    return getExperimentBoatsQuery(query, experimentVariant);
  }

  return getExperimentCarsQuery(query, experimentVariant);
};
